import { Box } from "@mui/material";
import styled from "styled-components";

export const RichTextSeparatorContainer = styled(Box)`
  width: 1px;
  background-color: #eee;
  margin: 0 4px;
`;
